import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import PartnerPage from "@/pages/PartnerPage";
import AsePage from "@/pages/AsePage";
import { PARTNER_LIST } from "@/data/partners";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const id = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 0);
    return () => clearTimeout(id);
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ase" element={<AsePage />} />
          {PARTNER_LIST.filter((p) => p.slug !== "ase").map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<PartnerPage config={p} />} />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
